module.exports = __webpack_public_path__ + "static/charlotte-a15ceccc737ffbaddf431a7cf4a903fb.m4a";